const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');

/** Builds the TypeBox schema fragment for the ShortText form element. */
function asDataDictionary(hNode, context) {
    const { id, title, propertyName, minLength, maxLength, pattern, required, defaultValue } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};
    // reuse consistent flags
    const { isOptional, schemaOptions } = moduleRegistration.resolveFieldFlags(required, context);
    const maybeOptional = schema => (isOptional ? Type.Optional(schema) : schema);

    // Build the string schema with constraints
    const stringOptions = {
        title: title,
        'x-id': id,
        'x-dataType': 'string',
        'x-propertyName': propertyName,
        ...schemaOptions
    };

    // Add constraints if provided
    if (minLength !== undefined && minLength !== null) {
        stringOptions.minLength = minLength;
    }
    if (maxLength !== undefined && maxLength !== null) {
        stringOptions.maxLength = maxLength;
    }
    if (pattern) {
        stringOptions.pattern = pattern;
    }
    if (defaultValue) {
        stringOptions.default = defaultValue;
    }

    const shortTextSchema = maybeOptional(Type.String(stringOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
        [propertyName]: shortTextSchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { asDataDictionary };
